/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Map_PickInputs */

const en_us2_progress_extra_map_pick = /** @type {(inputs: Progress_Extra_Map_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap a muscle to see its sets.`)
};

const pt_br2_progress_extra_map_pick = /** @type {(inputs: Progress_Extra_Map_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque num músculo para ver as séries.`)
};

const es_419_progress_extra_map_pick = /** @type {(inputs: Progress_Extra_Map_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca un músculo para ver sus series.`)
};

const pt_pt2_progress_extra_map_pick = /** @type {(inputs: Progress_Extra_Map_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca num músculo para veres as séries.`)
};

const fr_fr2_progress_extra_map_pick = /** @type {(inputs: Progress_Extra_Map_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Touche un muscle pour voir ses séries.`)
};

const de_de2_progress_extra_map_pick = /** @type {(inputs: Progress_Extra_Map_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe auf einen Muskel, um seine Sätze zu sehen.`)
};

const it_it2_progress_extra_map_pick = /** @type {(inputs: Progress_Extra_Map_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca un muscolo per vederne le serie.`)
};

/**
* | output |
* | --- |
* | "Tap a muscle to see its sets." |
*
* @param {Progress_Extra_Map_PickInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_map_pick = /** @type {((inputs?: Progress_Extra_Map_PickInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Map_PickInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_map_pick(inputs)
	if (locale === "es-419") return es_419_progress_extra_map_pick(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_map_pick(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_map_pick(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_map_pick(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_map_pick(inputs)
	return en_us2_progress_extra_map_pick(inputs)
});
export { progress_extra_map_pick as "progress-extra.map_pick" }